import React, { FC } from 'react';
import { IconProps } from '.';

export const UserIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg fill="none" {...sizing} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M19.88 18.83v1.42c0 .58-.47 1-1.06 1H5.06c-.59 0-1.06-.42-1.06-1v-1.42C4 16.5 6.7 13.81 9 13c.8-.28 2.13-.5 3-.5"
            />
            <path
                stroke="url(#e94b23fd)"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M14.36 13.03c2.21.8 5.52 2.91 5.52 5.8v1.11"
            />
            <path
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M7.18 7.75a4.75 4.75 0 1 1 4.75 4.75"
            />
            <path
                stroke="url(#233257747117)"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M11.94 12.51a4.77 4.77 0 0 1-4.76-4.76"
            />
            <defs>
                <linearGradient id="e94b23fd" x1="17.51" x2="15.22" y1="15" y2="13.53" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="233257747117"
                    x1="9.24"
                    x2="7.18"
                    y1="11.6"
                    y2="8.33"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentColor" stopOpacity="0" />
                    <stop offset="1" stopColor="currentColor" />
                </linearGradient>
            </defs>
        </svg>
    );
};
